import themeVariables from './theme-variables';
import theme from './current-theme';
export default themeVariables[theme];